import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { LineChart, BarChart, PieChart, TrendingUp } from "lucide-react"

const products = [
    {
        title: "Portfolio Analytics",
        description: "Advanced portfolio analysis and risk management tools powered by machine learning.",
        icon: LineChart,
        features: ["Risk Assessment", "Performance Tracking", "Asset Allocation"]
    },
    {
        title: "Market Intelligence",
        description: "Real-time market data and predictive analytics for informed decision-making.",
        icon: BarChart,
        features: ["Market Trends", "Sentiment Analysis", "Competitive Intelligence"]
    },
    {
        title: "Wealth Management Suite",
        description: "Comprehensive wealth management platform for high-net-worth clients.",
        icon: PieChart,
        features: ["Portfolio Management", "Tax Planning", "Estate Planning"]
    },
    {
        title: "Investment Automation",
        description: "Automated trading and investment strategies with customizable parameters.",
        icon: TrendingUp,
        features: ["Automated Trading", "Strategy Backtesting", "Risk Controls"]
    }
]

export function ProductGrid() {
    return (
        <div className="container mx-auto px-4 py-24">
            <div className="text-center mb-16">
                <h2 className="text-3xl font-bold tracking-tight">Investment Software Solutions</h2>
                <p className="mt-4 text-lg text-neutral-600 dark:text-neutral-400">
                    Cutting-edge technology for modern investment management
                </p>
            </div>

            <div className="grid gap-8 md:grid-cols-2">
                {products.map((product) => {
                    const Icon = product.icon
                    return (
                        <Card key={product.title} className="border-2">
                            <CardHeader>
                                <Icon className="h-8 w-8 mb-4 text-neutral-600 dark:text-neutral-400" />
                                <CardTitle className="text-xl">{product.title}</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <p className="text-neutral-600 dark:text-neutral-400 mb-4">
                                    {product.description}
                                </p>
                                <ul className="space-y-2">
                                    {product.features.map((feature) => (
                                        <li key={feature} className="text-sm text-neutral-600 dark:text-neutral-400">
                                            • {feature}
                                        </li>
                                    ))}
                                </ul>
                            </CardContent>
                        </Card>
                    )
                })}
            </div>
        </div>
    )
} 